/**
 * Created by Jew on 6/28/2017.
 */
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyButton as MatButton } from '@angular/material/legacy-button';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { TranslateService } from '@ngx-translate/core';
import { Toast } from 'app/shared/toast/toast';
import { WaitForImportComponent } from './wait-for-import.component';
import { GoogleDrivePageComponent } from '../google-drive-page/google-drive-page.component';
import {IdexService} from "../../idex.service";
import {SocialLogin} from "../../account/social-login";

declare const google: string;

@Component({
   selector: 'app-create-google-dialog',
   templateUrl: 'create-google-drive.component.html',
   styleUrls: ['create-google-drive.component.css']
})
export class CreateGoogleDriveComponent implements OnInit {
   private readonly SCOPE = 'https://www.googleapis.com/auth/drive.file';
   title: string;
   isBusiness: boolean;
   public canDrag: boolean;
   error: string;
   access_token: string;

   constructor(private dialogRef: MatDialogRef<CreateGoogleDriveComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private dialog: MatDialog,
      private translate: TranslateService, private toast: Toast,
      private service: IdexService,
      private socialLogin: SocialLogin) {
      this.title = 'Google ' + (this.data.createType === 'folder' ? 'Folder' : (this.data.type === 'spreadsheets' ? 'Sheet' : 'Doc'));
   }

   // see: https://developers.google.com/identity/sign-in/web/incremental-auth
   ngOnInit() {
      if (!sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.access_token = sessionStorage.getItem('access_token_google') as string;
         }, error => {
            this.data.toast.error(error);
         });
      } else {
         this.access_token = sessionStorage.getItem('access_token_google') as string;
      }
   }

   connectGoogle(button: MatButton, input: any) {
      if (input.value.length === 0) {
         input.focus();
         return;
      }
      if (/[<|>\\\/:?*"]/g.test(input.value)) {
         this.translate.get('alert.create_folder_error').subscribe(s => {
            this.error = s;
         });
         return;
      }
      const next = () => {
         if(this.data.component != null && this.data.component != undefined && this.data.component != '' && this.data.component === GoogleDrivePageComponent.name){
            if(this.data.createType === 'folder'){
               this.createFolderFromGoogleDrive(input.value.trim());
            }else{
               this.createFileFromGoogleDrive(input.value.trim());
            }
         }else{
            this.createFolder(input.value.trim());
         }
      };
      if (!sessionStorage.getItem('access_token_google')) {
         this.socialLogin.withGoogle().subscribe(result => {
            this.access_token = sessionStorage.getItem('access_token_google') as string;
            next();
         }, error => {
            this.data.toast.error(error);
         });
      } else {
         this.access_token = sessionStorage.getItem('access_token_google') as string;
         next();
      }
      this.dialogRef.close(true);
   }

   private async createFolder(filename: string) {
      this.dialogRef.close();
      const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this.data });
      const waiting = dialogRef.componentInstance;
      this.translate.get('googleDoc.create').subscribe(s => { waiting.message = s; });

      let response = await this.service.getFolderFromGoogleDrive(this.access_token, 'zDOX', 'root').toPromise();
      if (response.files.length === 0) {
         let createResponse = await this.service.createFolderInGoogleDrive(this.access_token, 'root', 'zDOX').toPromise();
         this.createFile(createResponse.id, filename, waiting);
      } else {
         this.createFile(response.files[0].id, filename, waiting);
      }
   }

   private createFile(folderId: string, fileName: string, waiting: WaitForImportComponent): void {
      let mimeType;
      if (this.data.type === 'spreadsheets') {
         mimeType = 'application/vnd.google-apps.spreadsheet';
      } else {
         mimeType = 'application/vnd.google-apps.document';
      }
      const type = this.data.type;
      this.service.createFileInGoogleDrive(this.access_token, folderId, fileName, mimeType).subscribe(res => {
         this.openDocFile(type,res.id);
         waiting.progress = false;
         this.translate.get('onedrive.save').subscribe(s => {
            waiting.message = s;
         });
         this.translate.get('onedrive.saveText').subscribe(s => {
            waiting.saveText = s;
         });
         waiting.status = 'drive';
         waiting.id = res.id;
         waiting.name = fileName;
         waiting.isBusiness = this.isBusiness;
         waiting.access_token = this.access_token;
         waiting.update();
      },error => {
         console.error(error);
      })
   }

   createFolderFromGoogleDrive(fileName: string) {
      this.service.createFolderInGoogleDrive(this.access_token, this.data.pathFolder, fileName).subscribe((res) => {
         this.dialogRef.close();
      })
   }

   private createFileFromGoogleDrive(fileName: string): void {
      try{
         this.dialogRef.close();
         const dialogRef = this.dialog.open(WaitForImportComponent, { disableClose: true, data: this.data });
         const waiting = dialogRef.componentInstance;
         this.translate.get('googleDoc.create').subscribe(s => { waiting.message = s; });
         let mimeType;
         if (this.data.type === 'spreadsheets') {
            mimeType = 'application/vnd.google-apps.spreadsheet';
         } else {
            mimeType = 'application/vnd.google-apps.document';
         }
         const type = this.data.type;
         this.service.createFileInGoogleDrive(this.access_token, this.data.pathFolder, fileName, mimeType).subscribe(res => {
            this.openDocFile(type,res.id);
            waiting.progress = false;
            this.translate.get('onedrive.save').subscribe(s => {
               waiting.message = s;
            });
            this.translate.get('onedrive.saveText').subscribe(s => {
               waiting.saveText = s;
            });
            waiting.status = 'drive';
            waiting.id = res.id;
            waiting.name = fileName;
            waiting.isBusiness = this.isBusiness;
            waiting.access_token = this.access_token;
            waiting.close();
         },error => {
            console.error(error);
         })
      }catch(e){
         console.error(e);
      }
   }

   openDocFile(type, id){
      const url = 'https://docs.google.com/' + type + '/d/' + id + '/edit';
      window.open(url);
   }
}
